import { doRequest } from "@/utils/api.js";
//手机号密码登录
export const doLogin = (data, callback) => {
  doRequest("/login/doLogin", data, "POST", callback);
};
//获取图形验证码
export const getCaptchaCode = (data, callback) => {
  doRequest("/login/getCaptchaCode", data, "GET", callback);
};
//手机号验证码登录
export const loginByCode = (data, callback) => {
  doRequest("/login/loginByCode", data, "POST", callback);
};
//获取用户信息
export const getUserInfo = (data, callback) => {
  doRequest("/login/getUserInfo", data, "GET", callback);
};
//发送验证码
export const sendVerification = (data, callback) => {
  doRequest(`/login/verifyCode`, data, "GET", callback);
};
//退出
export const logout = (data, callback) => {
  doRequest("/login/logout", data, "GET", callback);
};
//用户协议
export const getProtocol = (data, callback) => {
  doRequest("/protocol/getProtocol", data, "GET", callback);
};



// WEBPACK FOOTER //
// ./src/api/login/index.js